mobileMenu();

function mobileMenu() {
	let el = document.querySelectorAll('.menu-toggle');
	for (var i = 0; i < el.length; i++) {
		el[i].addEventListener('click', function () {
			document.querySelector('.main-navigation').classList.toggle('active');
			document.querySelector('.menu-bg').classList.toggle('active');
			// console.log('menu');
		});
	}
}

//our team slider
document.addEventListener('DOMContentLoaded', () => {
	let related = document.getElementsByClassName('ourteamslider');
	if (related.length === 0) return;

	if (related.length) {
		Array.from(related).forEach(heroCarousel => {
			let carousel = new Glide(heroCarousel, {
				type: 'carousel',
				animationDuration: 500,
				autoplay: 5000,
				gap: 16,
				perView: 2,
				peek: {
					before: 0,
					after: 70,
				},
				breakpoints: {
					575: {
						perView: 1
					}
				}
			});
			carousel.mount();
		});
	};
});

// //open and close modal popup by button click
// (function () {
// 	const overlay = document.querySelector('[data-modal-overlay]');
// 	if (!overlay) return;

// 	let activeModal = null;
// 	let lastFocusedElement = null;
// 	let scrollY = 0;

// 	const focusableSelectors = `
//     a[href],
//     button:not([disabled]),
//     textarea,
//     input,
//     select,
//     [tabindex]:not([tabindex="-1"])
//   `;

// 	function lockScroll() {
// 		scrollY = window.scrollY;
// 		document.body.classList.add('is-modal-open');
// 		document.body.style.top = `-${scrollY}px`;
// 	}

// 	function unlockScroll() {
// 		document.body.classList.remove('is-modal-open');
// 		document.body.style.top = '';
// 		window.scrollTo(0, scrollY);
// 	}

// 	function openModal(modal) {
// 		lastFocusedElement = document.activeElement;
// 		activeModal = modal;

// 		lockScroll();

// 		modal.style.display = 'block';
// 		overlay.style.display = 'block';
// 		modal.setAttribute('aria-hidden', 'false');

// 		const focusable = modal.querySelectorAll(focusableSelectors);
// 		(focusable[0] || modal).focus();

// 		document.addEventListener('keydown', handleKeydown);
// 	}

// 	function closeModal() {
// 		if (!activeModal) return;

// 		activeModal.style.display = 'none';
// 		activeModal.setAttribute('aria-hidden', 'true');
// 		overlay.style.display = 'none';

// 		unlockScroll();

// 		document.removeEventListener('keydown', handleKeydown);

// 		lastFocusedElement?.focus();
// 		activeModal = null;
// 	}

// 	function handleKeydown(e) {
// 		if (!activeModal) return;

// 		if (e.key === 'Escape') {
// 			closeModal();
// 		}

// 		if (e.key === 'Tab') {
// 			trapFocus(e);
// 		}
// 	}

// 	function trapFocus(e) {
// 		const focusable = activeModal.querySelectorAll(focusableSelectors);
// 		if (!focusable.length) return;

// 		const first = focusable[0];
// 		const last = focusable[focusable.length - 1];

// 		if (e.shiftKey && document.activeElement === first) {
// 			e.preventDefault();
// 			last.focus();
// 		} else if (!e.shiftKey && document.activeElement === last) {
// 			e.preventDefault();
// 			first.focus();
// 		}
// 	}

// 	// 🔹 open
// 	document.addEventListener('click', function (e) {
// 		const trigger = e.target.closest('[data-modal-open]');
// 		if (!trigger) return;

// 		e.preventDefault();

// 		const modalId = trigger.getAttribute('data-modal-open');
// 		const modal = document.getElementById(modalId);
// 		if (!modal) return;

// 		openModal(modal);
// 	});

// 	// 🔹 close by button
// 	document.addEventListener('click', function (e) {
// 		if (e.target.closest('[data-modal-close]')) {
// 			closeModal();
// 		}
// 	});

// 	//Resource Hub
// 	document.addEventListener('click', function (e) {
// 		const link = e.target.closest('.js-resourcehub');
// 		if (!link) return;

// 		const modal = document.querySelector('#resourcehub-1');
// 		if (!modal) return;

// 		e.preventDefault();
// 		openModal(modal);
// 	});

// 	//ask OSWALT
// 	document.addEventListener('click', function (e) {
// 		const link = e.target.closest('.js-oswalt');
// 		if (!link) return;

// 		const modal = document.querySelector('#js-oswalt');
// 		if (!modal) return;

// 		e.preventDefault();
// 		openModal(modal);
// 	});

// 	// 🔹 Закриття по overlay
// 	overlay.addEventListener('click', closeModal);
// })();


//open and close modal popup by button click Videogrey block
(function () {
	const overlay = document.querySelector('[data-modal-overlay]');
	if (!overlay) return;

	let activeModal = null;
	let lastFocusedElement = null;
	let scrollY = 0;

	const focusableSelectors = `
    a[href],
    button:not([disabled]),
    textarea,
    input,
    select,
    [tabindex]:not([tabindex="-1"])
  `;

	function lockScroll() {
		scrollY = window.scrollY;
		document.body.classList.add('is-modal-open');
		document.body.style.top = `-${scrollY}px`;
	}

	function unlockScroll() {
		document.body.classList.remove('is-modal-open');
		document.body.style.top = '';
		window.scrollTo(0, scrollY);
	}

	function openModal(modal, videoUrl = null) {
		lastFocusedElement = document.activeElement;
		activeModal = modal;

		lockScroll();

		modal.style.display = 'block';
		overlay.style.display = 'block';
		modal.setAttribute('aria-hidden', 'false');

		// 🔹 Якщо є відео — підставляємо src і запускаємо
		if (videoUrl) {
			const source = modal.querySelector('source');
			const video = modal.querySelector('video');
			if (source && video) {
				source.src = videoUrl;
				video.load();
				video.play();
			}
		}

		const focusable = modal.querySelectorAll(focusableSelectors);
		(focusable[0] || modal).focus();

		document.addEventListener('keydown', handleKeydown);
	}

	function closeModal() {
		if (!activeModal) return;

		// 🔹 Зупиняємо відео і очищаємо src
		const video = activeModal.querySelector('video');
		if (video) {
			video.pause();
			const source = activeModal.querySelector('source');
			if (source) source.src = '';
			video.load();
		}

		activeModal.style.display = 'none';
		activeModal.setAttribute('aria-hidden', 'true');
		overlay.style.display = 'none';

		unlockScroll();

		document.removeEventListener('keydown', handleKeydown);

		lastFocusedElement?.focus();
		activeModal = null;
	}

	function handleKeydown(e) {
		if (!activeModal) return;

		if (e.key === 'Escape') {
			closeModal();
		}

		if (e.key === 'Tab') {
			trapFocus(e);
		}
	}

	function trapFocus(e) {
		const focusable = activeModal.querySelectorAll(focusableSelectors);
		if (!focusable.length) return;

		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	}

	// 🔹 open
	document.addEventListener('click', function (e) {
		const trigger = e.target.closest('[data-modal-open]');
		if (!trigger) return;

		e.preventDefault();

		const modalId = trigger.getAttribute('data-modal-open');
		const modal = document.getElementById(modalId);
		if (!modal) return;

		const videoUrl = trigger.dataset.video || null;
		openModal(modal, videoUrl);
	});

	// 🔹 close by button
	document.addEventListener('click', function (e) {
		if (e.target.closest('[data-modal-close]')) {
			closeModal();
		}
	});

	//Resource Hub
	document.addEventListener('click', function (e) {
		const link = e.target.closest('.js-resourcehub');
		if (!link) return;

		const modal = document.querySelector('#resourcehub-1');
		if (!modal) return;

		e.preventDefault();
		openModal(modal);
	});

	//ask OSWALT
	document.addEventListener('click', function (e) {
		const link = e.target.closest('.js-oswalt');
		if (!link) return;

		const modal = document.querySelector('#js-oswalt');
		if (!modal) return;

		e.preventDefault();
		openModal(modal);
	});

	// 🔹 Закриття по overlay
	overlay.addEventListener('click', closeModal);
})();



document.addEventListener('DOMContentLoaded', function () {
	const copyBtn = document.getElementById('copy-link-btn');
	if (!copyBtn) return;
	copyBtn.addEventListener('click', function () {
		const url = window.location.href;
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(url).then(() => {
				copyBtn.querySelector('.copied').style.display = 'block';
			}).catch(err => {
				console.error("Clipboard error:", err);
			});
		} else {
			// Fallback 
			const textarea = document.createElement('textarea');
			textarea.value = url;
			textarea.style.position = 'fixed';
			textarea.style.left = '-9999px';
			document.body.appendChild(textarea);

			textarea.select();
			document.execCommand('copy');
			document.body.removeChild(textarea);

			copyBtn.querySelector('.copied').style.display = 'block';
		}
		setTimeout(() => {
			copyBtn.querySelector('.copied').style.display = 'none';
		}, 3000);

	});

});

//FAQ
// document.addEventListener('DOMContentLoaded', () => {
// 	const items = document.querySelectorAll('.faq-item');

// 	items.forEach(item => {
// 		const question = item.querySelector('.faq-question');
// 		const answer = item.querySelector('.faq-answer');

// 		question.addEventListener('click', () => {
// 			const isOpen = item.classList.contains('active');

// 			// items.forEach(i => {
// 			// 	i.classList.remove('active');
// 			// 	i.querySelector('.faq-answer').style.maxHeight = null;
// 			// });
// 			// if (!isOpen) {
// 			// 	item.classList.add('active');
// 			// 	answer.style.maxHeight = answer.scrollHeight + 'px';
// 			// }


// 			if (!isOpen) {
// 				item.classList.add('active');
// 				answer.style.maxHeight = answer.scrollHeight + 'px';
// 			} else {
// 				item.classList.remove('active');
// 				item.querySelector('.faq-answer').style.maxHeight = null;
// 			}
// 		});
// 	});
// });

document.addEventListener('DOMContentLoaded', () => {
	const items = document.querySelectorAll('.faq-item');

	items.forEach(item => {
		const question = item.querySelector('.faq-question');
		const answer = item.querySelector('.faq-answer');

		question.addEventListener('click', () => {
			const isOpen = item.classList.contains('active');

			if (!isOpen) {
				item.classList.add('active');
				answer.style.maxHeight = answer.scrollHeight + 'px';
				question.setAttribute('aria-expanded', 'true');
				answer.setAttribute('aria-hidden', 'false');
			} else {
				item.classList.remove('active');
				answer.style.maxHeight = null;
				question.setAttribute('aria-expanded', 'false');
				answer.setAttribute('aria-hidden', 'true');
			}
		});
	});
});

function references(question) {
	const parentElem = question.parentElement;
	const answer = parentElem.querySelector('.faq-answer')
	const isOpen = parentElem.classList.contains('active');

	if (!isOpen) {
		parentElem.classList.add('active');
		answer.style.maxHeight = answer.scrollHeight + 'px';
		question.setAttribute('aria-expanded', 'true');
		answer.setAttribute('aria-hidden', 'false');
	} else {
		parentElem.classList.remove('active');
		answer.style.maxHeight = null;
		question.setAttribute('aria-expanded', 'false');
		answer.setAttribute('aria-hidden', 'true');
	}
}


// // Blog post modal
// document.addEventListener('DOMContentLoaded', () => {

// 	// --- Create modal overlay ---
// 	document.body.insertAdjacentHTML('beforeend', `
// 	  <div id="post-modal-overlay">
// 		<div id="post-modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
// 		  <button id="post-modal-close" aria-label="Close">
// 		  	<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
// 				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
// 				<path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"></path>
// 				<path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"></path>
// 	  		</svg>
// 	  	</button>
// 		  <div id="post-modal-content" class="post-content-wrapper"></div>
// 		</div>
// 	  </div>
// 	`);

// 	const overlay  = document.getElementById('post-modal-overlay');
// 	const closeBtn = document.getElementById('post-modal-close');
// 	const content  = document.getElementById('post-modal-content');
// 	const mainContent = document.querySelector('#page') || document.querySelector('main');

// 	let lastFocused = null;

// 	// --- Focus trap ---
// 	function trapFocus(e) {
// 		if (e.key !== 'Tab') return;

// 		const focusable = Array.from(overlay.querySelectorAll(
// 			'button, a, input, textarea, select, [tabindex]:not([tabindex="-1"])'
// 		)).filter(el => !el.disabled);

// 		const first = focusable[0];
// 		const last  = focusable[focusable.length - 1];

// 		if (e.shiftKey && document.activeElement === first) {
// 			e.preventDefault();
// 			last.focus();
// 		} else if (!e.shiftKey && document.activeElement === last) {
// 			e.preventDefault();
// 			first.focus();
// 		}
// 	}

// 	// --- Open modal ---
// 	function openModal(postId) {
// 		content.innerHTML = '<div class="modal-spinner"></div>';
// 		overlay.classList.add('active');
// 		document.body.classList.add('modal-open');
// 		mainContent?.setAttribute('aria-hidden', 'true');
// 		closeBtn.focus();

// 		document.addEventListener('keydown', trapFocus);

// 		const formData = new FormData();
// 		formData.append('action', 'load_post_modal');
// 		formData.append('post_id', postId);

// 		fetch(itk_ajax_params.ajaxurl, {
// 			method: 'POST',
// 			body: formData,
// 		})
// 			.then(res => res.json())
// 			.then(res => {
// 				if (!res.success) throw new Error('Post not found');
// 				const d = res.data;
// 				content.innerHTML = `
// 					<div class="modal-header">
// 					  ${d.thumbnail ? `<div class="modal-thumbnail">${d.thumbnail}</div>` : ''}
// 					  <span class="modal-date">${d.date}</span>
// 					  <h2 class="modal-title" id="modal-title">${d.title}</h2>
// 					</div>
// 					<div class="modal-body">${d.content}</div>
// 				`;
// 			})
// 			.catch(() => {
// 				content.innerHTML = '<p class="modal-error">Failed to load the post.</p>';
// 			});
// 	}

// 	// --- Close modal ---
// 	function closeModal() {
// 		overlay.classList.remove('active');
// 		document.body.classList.remove('modal-open');
// 		mainContent?.removeAttribute('aria-hidden');
// 		document.removeEventListener('keydown', trapFocus);
// 		if (lastFocused) lastFocused.focus();
// 	}

// 	// --- Intercept clicks on post links ---
// 	document.addEventListener('click', (e) => {
// 		const link = e.target.closest('a[data-post-id]');
// 		if (!link) return;
// 		e.preventDefault();
// 		lastFocused = link;
// 		openModal(link.dataset.postId);
// 	});

// 	// --- Close handlers ---
// 	closeBtn.addEventListener('click', closeModal);

// 	overlay.addEventListener('click', (e) => {
// 		if (e.target === overlay) closeModal();
// 	});

// 	document.addEventListener('keydown', (e) => {
// 		if (e.key === 'Escape' && overlay.classList.contains('active')) closeModal();
// 	});

// });


//================start old modal by category for STRENGTH TOOLS======================================
// // Blog post modal with carousel navigation
// document.addEventListener('DOMContentLoaded', () => {

// 	// --- Create modal overlay ---
// 	document.body.insertAdjacentHTML('beforeend', `
// 	  <div id="post-modal-overlay">
// 		<div id="post-modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
// 		  <button id="post-modal-close" aria-label="Close">
// 		  	<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
// 				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
// 				<path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"></path>
// 				<path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"></path>
// 		  	</svg>
// 		  </button>

// 		  <button id="post-modal-prev" aria-label="Previous post">
// 		  	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="60" height="60">
// 				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
// 				<path d="M27 14 L17 24 L27 34" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
// 		  	</svg>
// 		  </button>

// 		  <button id="post-modal-next" aria-label="Next post">
// 		  	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="60" height="60">
// 				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
// 				<path d="M21 14 L31 24 L21 34" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
// 		  	</svg>
// 		  </button>

// 		  <div id="post-modal-counter" aria-live="polite"></div>
// 		  <div id="post-modal-content" class="post-content-wrapper"></div>
// 		</div>
// 	  </div>
// 	`);

// 	const overlay = document.getElementById('post-modal-overlay');
// 	const closeBtn = document.getElementById('post-modal-close');
// 	const prevBtn = document.getElementById('post-modal-prev');
// 	const nextBtn = document.getElementById('post-modal-next');
// 	const counter = document.getElementById('post-modal-counter');
// 	const content = document.getElementById('post-modal-content');
// 	const mainContent = document.querySelector('#page') || document.querySelector('main');

// 	let lastFocused = null;
// 	let postIds = [];
// 	let currentIndex = 0;

// 	// --- Collect all post IDs from the page (in DOM order) ---
// 	function collectPostIds() {
// 		const seen = new Set();
// 		const ids = [];
// 		document.querySelectorAll('a[data-post-id]').forEach(link => {
// 			const id = link.dataset.postId;
// 			if (id && !seen.has(id)) {
// 				seen.add(id);
// 				ids.push(id);
// 			}
// 		});
// 		return ids;
// 	}

// 	// --- Update navigation visibility ---
// 	function updateNavigation() {
// 		counter.textContent = postIds.length > 1
// 			? `${currentIndex + 1} / ${postIds.length}`
// 			: '';

// 		// Показати/сховати стрілки
// 		prevBtn.style.display = postIds.length > 1 ? '' : 'none';
// 		nextBtn.style.display = postIds.length > 1 ? '' : 'none';
// 	}

// 	// --- Focus trap ---
// 	function trapFocus(e) {
// 		if (e.key !== 'Tab') return;

// 		const focusable = Array.from(overlay.querySelectorAll(
// 			'button:not([disabled]), a, input, textarea, select, [tabindex]:not([tabindex="-1"])'
// 		)).filter(el => !el.disabled);

// 		const first = focusable[0];
// 		const last = focusable[focusable.length - 1];

// 		if (e.shiftKey && document.activeElement === first) {
// 			e.preventDefault();
// 			last.focus();
// 		} else if (!e.shiftKey && document.activeElement === last) {
// 			e.preventDefault();
// 			first.focus();
// 		}
// 	}

// 	// --- Load post into modal ---
// 	function loadPost(postId) {
// 		content.innerHTML = '<div class="modal-spinner"></div>';
// 		updateNavigation();

// 		const formData = new FormData();
// 		formData.append('action', 'load_post_modal');
// 		formData.append('post_id', postId);

// 		fetch(itk_ajax_params.ajaxurl, {
// 			method: 'POST',
// 			body: formData,
// 		})
// 			.then(res => res.json())
// 			.then(res => {
// 				if (!res.success) throw new Error('Post not found');
// 				const d = res.data;
// 				content.innerHTML = `
// 					<div class="modal-header">
// 					  ${d.thumbnail ? `<div class="modal-thumbnail">${d.thumbnail}</div>` : ''}
// 					</div>
// 					<div class="modal-body">
// 					<h2 class="modal-title" id="modal-title">${d.title}</h2>
// 					${d.content}</div>
// 				`;
// 				content.scrollTop = 0;
// 			})
// 			.catch(() => {
// 				content.innerHTML = '<p class="modal-error">Failed to load the post.</p>';
// 			});
// 	}

// 	// --- Open modal ---
// 	function openModal(postId) {
// 		postIds = collectPostIds();
// 		currentIndex = postIds.indexOf(postId);
// 		if (currentIndex === -1) currentIndex = 0;

// 		document.body.style.overflow = 'hidden';
// 		overlay.classList.add('active');
// 		mainContent?.setAttribute('aria-hidden', 'true');
// 		closeBtn.focus();

// 		document.addEventListener('keydown', trapFocus);

// 		loadPost(postId);
// 	}

// 	// --- Open modal from category (AJAX load posts by category) ---
// 	function openModalByCategory(categoryId) {
// 		content.innerHTML = '<div class="modal-spinner"></div>';
// 		overlay.classList.add('active');
// 		document.body.style.overflow = 'hidden';
// 		mainContent?.setAttribute('aria-hidden', 'true');
// 		closeBtn.focus();
// 		document.addEventListener('keydown', trapFocus);

// 		const formData = new FormData();
// 		formData.append('action', 'load_category_posts');
// 		formData.append('category_id', categoryId);

// 		fetch(itk_ajax_params.ajaxurl, {
// 			method: 'POST',
// 			body: formData,
// 		})
// 			.then(res => res.json())
// 			.then(res => {
// 				if (!res.success && res.data?.empty) {
// 					content.innerHTML = '<p class="modal-error">No articles found in this category yet.</p>';
// 					postIds = [];
// 					updateNavigation();
// 					return;
// 				}
// 				if (!res.success || !res.data.length) throw new Error('Failed to load posts.');

// 				postIds      = res.data.map(p => String(p.id));
// 				currentIndex = 0;
// 				loadPost(postIds[0]);
// 			})
// 			.catch((err) => {
// 				content.innerHTML = `<p class="modal-error">${err.message}</p>`;
// 			});
// 	}

// 	// --- Close modal ---
// 	function closeModal() {
// 		overlay.classList.remove('active');
// 		document.body.style.overflow = '';
// 		mainContent?.removeAttribute('aria-hidden');
// 		document.removeEventListener('keydown', trapFocus);
// 		if (lastFocused) lastFocused.focus();
// 	}

// 	// --- Navigate ---
// 	function goToPrev() {
// 		currentIndex = (currentIndex - 1 + postIds.length) % postIds.length;
// 		loadPost(postIds[currentIndex]);
// 	}

// 	function goToNext() {
// 		currentIndex = (currentIndex + 1) % postIds.length;
// 		loadPost(postIds[currentIndex]);
// 	}

// 	// --- Touch swipe ---
// 	let touchStartX = 0;
// 	let touchStartY = 0;

// 	overlay.addEventListener('touchstart', (e) => {
// 		touchStartX = e.touches[0].clientX;
// 		touchStartY = e.touches[0].clientY;
// 	}, { passive: true });

// 	overlay.addEventListener('touchend', (e) => {
// 		const dx = e.changedTouches[0].clientX - touchStartX;
// 		const dy = e.changedTouches[0].clientY - touchStartY;

// 		if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

// 		if (dx < 0) goToNext();
// 		else goToPrev();
// 	}, { passive: true });

// 	// --- Intercept clicks on post links ---
// 	document.addEventListener('click', (e) => {
// 		// Клік на статтю
// 		const postLink = e.target.closest('a[data-post-id]');
// 		if (postLink) {
// 			e.preventDefault();
// 			lastFocused = postLink;
// 			openModal(postLink.dataset.postId);
// 			return;
// 		}

// 		// Клік на категорію
// 		const catLink = e.target.closest('a[data-category-id]');
// 		if (catLink) {
// 			e.preventDefault();
// 			lastFocused = catLink;
// 			openModalByCategory(catLink.dataset.categoryId);
// 			return;
// 		}
// 	});

// 	prevBtn.addEventListener('click', goToPrev);
// 	nextBtn.addEventListener('click', goToNext);

// 	closeBtn.addEventListener('click', closeModal);

// 	overlay.addEventListener('click', (e) => {
// 		if (e.target === overlay) closeModal();
// 	});

// 	document.addEventListener('keydown', (e) => {
// 		if (!overlay.classList.contains('active')) return;
// 		if (e.key === 'Escape') closeModal();
// 		if (e.key === 'ArrowLeft') goToPrev();
// 		if (e.key === 'ArrowRight') goToNext();
// 	});

// });

// Blog post modal with carousel navigation (per-category)
document.addEventListener('DOMContentLoaded', () => {

	// --- Create modal overlay ---
	document.body.insertAdjacentHTML('beforeend', `
	  <div id="post-modal-overlay">
		<div id="post-modal" role="dialog" aria-modal="true" aria-labelledby="modal-title">
		  <button id="post-modal-close" aria-label="Close">
		  	<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 48 48">
				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
				<path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z"></path>
				<path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z"></path>
		  	</svg>
		  </button>

		  <button id="post-modal-prev" aria-label="Previous post">
		  	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="60" height="60">
				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
				<path d="M27 14 L17 24 L27 34" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
		  	</svg>
		  </button>

		  <button id="post-modal-next" aria-label="Next post">
		  	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="60" height="60">
				<path class="bg" fill="#a28d60" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path>
				<path d="M21 14 L31 24 L21 34" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
		  	</svg>
		  </button>

		  <div id="post-modal-content" class="post-content-wrapper"></div>
		</div>
	  </div>
	`);

	const overlay = document.getElementById('post-modal-overlay');
	const closeBtn = document.getElementById('post-modal-close');
	const prevBtn = document.getElementById('post-modal-prev');
	const nextBtn = document.getElementById('post-modal-next');
	// const counter   = document.getElementById('post-modal-counter');
	const content = document.getElementById('post-modal-content');
	const mainContent = document.querySelector('#page') || document.querySelector('main');

	let lastFocused = null;
	let postIds = [];
	let currentIndex = 0;

	// --- Collect post IDs from the same .sub-filters as the clicked link ---
	function collectPostIdsFromGroup(clickedLink) {
		const subFilters = clickedLink.closest('.sub-filters');
		if (!subFilters) {
			// fallback: зібрати всі з усієї сторінки
			return Array.from(document.querySelectorAll('a[data-post-id]'))
				.map(a => a.dataset.postId)
				.filter(Boolean);
		}
		return Array.from(subFilters.querySelectorAll('a[data-post-id]'))
			.map(a => a.dataset.postId)
			.filter(Boolean);
	}

	// --- Update navigation visibility ---
	function updateNavigation() {
		// counter.textContent = postIds.length > 1
		// 	? `${currentIndex + 1} / ${postIds.length}`
		// 	: '';

		prevBtn.style.display = postIds.length > 1 ? '' : 'none';
		nextBtn.style.display = postIds.length > 1 ? '' : 'none';
	}

	// --- Focus trap ---
	function trapFocus(e) {
		if (e.key !== 'Tab') return;

		const focusable = Array.from(overlay.querySelectorAll(
			'button:not([disabled]), a, input, textarea, select, [tabindex]:not([tabindex="-1"])'
		)).filter(el => !el.disabled);

		const first = focusable[0];
		const last = focusable[focusable.length - 1];

		if (e.shiftKey && document.activeElement === first) {
			e.preventDefault();
			last.focus();
		} else if (!e.shiftKey && document.activeElement === last) {
			e.preventDefault();
			first.focus();
		}
	}

	// --- Load post into modal ---
	function loadPost(postId) {
		content.innerHTML = '<div class="modal-spinner"></div>';
		updateNavigation();

		const formData = new FormData();
		formData.append('action', 'load_post_modal');
		formData.append('post_id', postId);

		fetch(itk_ajax_params.ajaxurl, {
			method: 'POST',
			body: formData,
		})
			.then(res => res.json())
			.then(res => {
				if (!res.success) throw new Error('Post not found');
				const d = res.data;
				content.innerHTML = `
					<div class="modal-header">
					  ${d.thumbnail ? `<div class="modal-thumbnail">${d.thumbnail}</div>` : ''}
					</div>
					<div class="modal-body">
					  <h2 class="modal-title" id="modal-title">${d.title}</h2>
					  ${d.content}
					  ${d.disclaimer}
					</div>
				`;
				content.scrollTop = 0;
			})
			.catch(() => {
				content.innerHTML = '<p class="modal-error">Failed to load the post.</p>';
			});
	}

	// --- Open modal ---
	function openModal(postId, clickedLink) {
		postIds = collectPostIdsFromGroup(clickedLink);
		currentIndex = postIds.indexOf(String(postId));
		if (currentIndex === -1) currentIndex = 0;

		document.body.style.overflow = 'hidden';
		overlay.classList.add('active');
		mainContent?.setAttribute('aria-hidden', 'true');
		closeBtn.focus();

		document.addEventListener('keydown', trapFocus);

		loadPost(postId);
	}

	// --- Close modal ---
	function closeModal() {
		overlay.classList.remove('active');
		document.body.style.overflow = '';
		mainContent?.removeAttribute('aria-hidden');
		document.removeEventListener('keydown', trapFocus);
		if (lastFocused) lastFocused.focus();
	}

	// --- Navigate ---
	function goToPrev() {
		currentIndex = (currentIndex - 1 + postIds.length) % postIds.length;
		loadPost(postIds[currentIndex]);
	}

	function goToNext() {
		currentIndex = (currentIndex + 1) % postIds.length;
		loadPost(postIds[currentIndex]);
	}

	// --- Touch swipe ---
	let touchStartX = 0;
	let touchStartY = 0;

	overlay.addEventListener('touchstart', (e) => {
		touchStartX = e.touches[0].clientX;
		touchStartY = e.touches[0].clientY;
	}, { passive: true });

	overlay.addEventListener('touchend', (e) => {
		const dx = e.changedTouches[0].clientX - touchStartX;
		const dy = e.changedTouches[0].clientY - touchStartY;

		if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

		if (dx < 0) goToNext();
		else goToPrev();
	}, { passive: true });

	// --- Intercept clicks on post links ---
	document.addEventListener('click', (e) => {
		const postLink = e.target.closest('a[data-post-id]');
		if (postLink) {
			e.preventDefault();
			lastFocused = postLink;
			openModal(postLink.dataset.postId, postLink);
			return;
		}
	});

	prevBtn.addEventListener('click', goToPrev);
	nextBtn.addEventListener('click', goToNext);

	closeBtn.addEventListener('click', closeModal);

	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) closeModal();
	});

	document.addEventListener('keydown', (e) => {
		if (!overlay.classList.contains('active')) return;
		if (e.key === 'Escape') closeModal();
		if (e.key === 'ArrowLeft') goToPrev();
		if (e.key === 'ArrowRight') goToNext();
	});

});


//our Posts slider
document.addEventListener('DOMContentLoaded', () => {
	let related = document.getElementsByClassName('mob-ourposts');

	if (related) {
		if (related.length === 0) return;

		if (related.length) {
			Array.from(related).forEach(heroCarousel => {
				let carousel = new Glide(heroCarousel, {
					type: 'carousel',
					animationDuration: 500,
					autoplay: 5000,
					gap: 16,
					perView: 2,
					peek: {
						before: 0,
						after: 220,
					},
					breakpoints: {
						767: {
							perView: 2,
							peek: {
								before: 0,
								after: 220,
							},
						},
						575: {
							perView: 1,
							peek: {
								before: 0,
								after: 100,
							},
						}
					}
				});
				carousel.mount();
			});
		};
	};
});

// function loadPodcast(btn) {
// 	const wrap = btn.closest('.podcast-wrap');
// 	const src = wrap.dataset.src;
// 	const iframe = document.createElement('iframe');
// 	iframe.src = src;
// 	iframe.width = '100%';
// 	iframe.height = '180';
// 	iframe.setAttribute('frameborder', 'no');
// 	iframe.setAttribute('scrolling', 'no');
// 	iframe.setAttribute('seamless', '');
// 	iframe.setAttribute('loading', 'eager');
// 	wrap.replaceWith(iframe);
// }

//book carousel
const track = document.querySelector('.coverflow-track');
if (track) {
	const slides = document.querySelectorAll('.slide');

	let current = 0;
	let startX = 0;
	let currentX = 0;
	let isDragging = false;

	// function update() {
	//   slides.forEach(slide => {
	//     slide.className = 'slide';
	//   });

	//   const total = slides.length;
	//   const getIndex = (i) => (i + total) % total;

	//   slides[getIndex(current)].classList.add('center');
	//   slides[getIndex(current - 1)].classList.add('left1');
	//   slides[getIndex(current + 1)].classList.add('right1');
	//   slides[getIndex(current - 2)].classList.add('left2');
	//   slides[getIndex(current + 2)].classList.add('right2');
	// }
	function update() {
		const total = slides.length;

		// нормалізуємо current
		current = normalizeIndex(current, total);

		slides.forEach(slide => {
			slide.className = 'slide';
		});

		const getIndex = (i) => normalizeIndex(i, total);

		slides[getIndex(current)].classList.add('center');
		slides[getIndex(current - 1)].classList.add('left1');
		slides[getIndex(current + 1)].classList.add('right1');
		slides[getIndex(current - 2)].classList.add('left2');
		slides[getIndex(current + 2)].classList.add('right2');
	}
	function normalizeIndex(i, total) {
		return ((i % total) + total) % total;
	}

	function next() {
		current++;
		update();
	}

	function prev() {
		current--;
		update();
	}

	// --- TOUCH / MOUSE LOGIC ---

	function startDrag(x) {
		startX = x;
		isDragging = true;
	}

	function moveDrag(x) {
		if (!isDragging) return;
		currentX = x;
	}

	function endDrag() {
		if (!isDragging) return;

		const diff = startX - currentX;

		// поріг свайпу
		if (Math.abs(diff) > 50) {
			if (diff > 0) {
				next();
			} else {
				prev();
			}
		}

		isDragging = false;
	}

	// touch events
	track.addEventListener('touchstart', (e) => {
		startDrag(e.touches[0].clientX);
	});

	track.addEventListener('touchmove', (e) => {
		moveDrag(e.touches[0].clientX);
	});

	track.addEventListener('touchend', endDrag);

	// mouse events
	// track.addEventListener('mousedown', (e) => {
	// 	startDrag(e.clientX);
	// });

	// track.addEventListener('mousemove', (e) => {
	// 	moveDrag(e.clientX);
	// });

	// track.addEventListener('mouseup', endDrag);
	// track.addEventListener('mouseleave', endDrag);

	// кнопки
	document.querySelector('.next').onclick = next;
	document.querySelector('.prev').onclick = prev;

	update();
}